// extracted by mini-css-extract-plugin
export default {"favorites":"Recommended_favorites__pRAbO","header":"Recommended_header__dQDWM","cards":"Recommended_cards__CqvhX","viewMore":"Recommended_viewMore__AUET7"};